import { render, staticRenderFns } from "./IconSms.vue?vue&type=template&id=0fbfd899&scoped=true&"
import script from "./IconSms.vue?vue&type=script&lang=js&"
export * from "./IconSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbfd899",
  null
  
)

export default component.exports